/**
 * Rate limits for the "Recherche d'entreprises" API (requests per second)
 * @see https://recherche-entreprises.api.gouv.fr
 */
export const RECHERCHE_ENTREPRISES_RATE_LIMITS = {
  search: 7,
} as const;
